import React from "react";
import { ColorsContext } from "../context/entity-collections";
export var useColors = function () {
  return React.useContext(ColorsContext) || [];
};
export var useColor = function (slug) {
  var colors = useColors();
  return colors.find(function (color) {
    return color.slug === slug;
  });
};